<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handlePublish"
    @cancel="handleCancel"
    cancelText="关闭"
    okText="发布"
  >
    <a-form :form="form">
      <a-form-model-item
        label="产品代码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          show-search
          placeholder="请选择产品代码"
          optionFilterProp="label"
          v-decorator="['fundCode', validatorRules.fundCode]"
        >
          <a-select-option
            v-for="item in fundCodeList"
            :key="item"
            :label="item"
          >
            {{ item }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item
        label="净值日期"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-date-picker
          placeholder="请选择净值日期"
          style="width: 100%"
          v-decorator="['releaseDate', validatorRules.netValueDate]"
        />
      </a-form-item>
      <a-form-item
        label="手工产品净值"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="['manualNetValue', validatorRules.manualNetValue]"
          placeholder="请输入单位净值"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="手工累计净值"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'manualTotalNetValue',
            validatorRules.manualTotalNetValue,
          ]"
          placeholder="请输入累计净值"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="手工每万份计划收益"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'manualIncomeUnit',
            validatorRules.manualTenThousandPlanBenefits,
          ]"
          placeholder="请输入手工每万份计划收益（元）"
        ></a-input>
      </a-form-item>
      <a-form-item
        label="手工7日年化收益率"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'manualIncomeRatio',
            validatorRules.manualSevenDaysAnnualizedReturn,
          ]"
          placeholder="请输入手工7日年化收益率（%）"
        ></a-input>
      </a-form-item>
    </a-form>
  </j-modal>
</template>

<script>
import { getAction } from '@/api/manage';
import JDictSelectTag from '@/components/dict/JDictSelectTag';
import { netValueEdit } from '@/api/product';
export default {
  name: 'ProductsFundEquityModal',
  components: {
    JDictSelectTag,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      title: '发布',
      width: 800,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {
        fundCode: {
          rules: [{ required: true, message: '请输入产品代码!' }],
        },
        netValueDate: {
          rules: [{ required: true, message: '请输入净值日期' }],
        },
        manualNetValue: {
          rules: [
            {
              validator: this.validateValue,
            },
          ],
        },
        manualTotalNetValue: {
          rules: [
            {
              validator: this.validateValue,
            },
          ],
        },
        manualTenThousandPlanBenefits: {
          rules: [
            {
              validator: this.validateValue,
            },
          ],
        },
        manualSevenDaysAnnualizedReturn: {
          rules: [
            {
              validator: this.validateValue,
            },
          ],
        },
      },
      url: process.env.VUE_APP_CMS_PRODUCT + '/product/productsFundValue/add',
      fundCodeList: [], //下拉列表数据
    };
  },
  created() {
    this.getFundCodeList();
  },
  methods: {
    getFundCodeList() {
      getAction(
        process.env.VUE_APP_CMS_PRODUCT + '/product/fund/fundCodes'
      ).then((res) => {
        if (res.success) {
          this.fundCodeList = res.result && res.result ? res.result : [];
        } else {
          this.$message.error(res.message);
        }
      });
    },

    handleCancel() {
      this.visible = false;
    },

    handlePublish() {
      this.form.validateFields((err, values) => {
        if (!err) {
          let manualNetValue =
            values.manualNetValue == '' ? null : values.manualNetValue;
          let manualTotalNetValue =
            values.manualTotalNetValue == ''
              ? null
              : values.manualTotalNetValue;
          let manualIncomeUnit =
            values.manualIncomeUnit == '' ? null : values.manualIncomeUnit;
          let manualIncomeRatio =
            values.manualIncomeRatio == '' ? null : values.manualIncomeRatio;
          let params = {
            fundCode: values.fundCode,
            releaseDate: values.releaseDate,
            manualNetValue,
            manualTotalNetValue,
            manualIncomeUnit,
            manualIncomeRatio,
          };
          netValueEdit(params).then((res) => {
            if (res.success) {
              this.$emit('ok');
              this.visible = false;
              this.form.resetFields();

              this.$message.success(res.message);
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
    validateValue(rule, value, callback) {
      if (!value) {
        callback();
      } else {
        let regex = /^\d+$|^\d*\.\d+$/g;
        if (regex.test(value)) {
          let rep = /[\.]/;
          if (rep.test(value)) {
            let arr = value.split('.');
            if (arr[0].length > 3 || arr[1].length > 8) {
              callback('长度超出限制');
            } else {
              callback();
            }
          } else if (value.length > 3) {
            callback('长度超出限制');
          } else {
            callback();
          }
        } else {
          callback('只能输入数字');
        }
      }
    },
  },
};
</script>
